<template>
  <div class="position-is-primary">
    <label>
      <input
        type="checkbox"
        class="pb-3"
        :checked="isChecked"
        @change="handleCheckboxChange"
      />
      <span class="help">Is Primary</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'PositionIsPrimary',
  props: {
    value: {
      type: String
    },
    positionId: {
      type: Number
    },
    jobTitleId: {
      type: Number
    }
  },
  computed: {
    initValue () {
      return this.value
    },
    isChecked () {
      return this.value === 'true'
    }
  },
  methods: {
    async handleCheckboxChange (event) {
      const value = event.target.checked ? 'true' : 'false'

      try {
        await this.$network_utils.updatePositionJobTitle({
          position_id: this.positionId,
          job_title_id: this.jobTitleId,
          is_primary: value
        })
        this.$emit('input', value)
        this.$utils.emit('show_toast', { text: 'הצלחה' })
      } catch (e) {
        console.error(e)
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
